(function () {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .factory('sensionRepository', sensionRepository);

  sensionRepository.$inject = ['sensionMessage', 'mtypes', 'sensionData'];

  function sensionRepository(sensionMessage, mtypes, sensionData) {

    var service = {
      deviceSupportsSension: false,
      sensionError: '',
      showInfo: showInfo,
      infoMessage: infoMessage,
      showError: showError,
      errorMessage: errorMessage,
      noRetake: noRetake,
      noCModuleActionButton: noCModuleActionButton
    };

    return service;

    ///////////////

    function showInfo(cModule) {
      if(!cModule)
        return false;

      if(!service.deviceSupportsSension)
        return false;

      return hasSensionUsage(cModule) && noMissedDeadline(cModule);
    }

    function infoMessage(cModule) {
      if(!cModule)
        return '';

      return sensionMessage.info(cModule.sensionUsage, cModule.type);
    }

    function showError(cModule) {
      if(!cModule)
        return false;

      if(service.deviceSupportsSension)
        return false;

      return hasUsageRequirement(cModule) && noMissedDeadline(cModule);
    }

    function errorMessage(cModule) {
      if(!cModule)
        return '';

      return sensionMessage.error(service.sensionError, cModule.type);
    }

    function noRetake(cModule) {
      return showError(cModule) && !!~_.indexOf([sensionData.NO_FLASH, sensionData.NO_CAMERA], service.sensionError);
    }

    function noCModuleActionButton(cModule) {
      return !service.deviceSupportsSension && hasUsageRequirement(cModule) || cModule.type == 'catalog';
    }


    function hasUsageRequirement(cModule) {
      return cModule.sensionUsage == mtypes.sensionUsage.requireEngagement;
    }

    function hasSensionUsage(cModule) {
      return _.contains(_.omit(mtypes.sensionUsage, 'none'), cModule.sensionUsage);
    }

    function noMissedDeadline(cModule) {
      return !(cModule.status == 'missedcompletiondeadline' && !cModule.catalogId);
    }
  }

})();
